var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqElectric = function SvgFaqElectric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-electric_svg__a)",
    fillRule: "evenodd",
    d: "M8 17.2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v.8a2 2 0 0 1-1.6 1.96V20a1.6 1.6 0 0 1-3.2 0h-6.4a1.6 1.6 0 0 1-3.2 0v-.04A2 2 0 0 1 8 18zm2.4 1.2a.8.8 0 1 0 0-1.6.8.8 0 0 0 0 1.6m12-.8a.8.8 0 1 1-1.6 0 .8.8 0 0 1 1.6 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-electric_svg__b)",
    fillRule: "evenodd",
    d: "M10.063 13.6h11.873l-.816-2.176a1.58 1.58 0 0 0-1.478-1.024h-7.285c-.658 0-1.248.408-1.479 1.024z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#faq-electric_svg__c)",
    fillRule: "evenodd",
    d: "M2.6 16C2.6 8.6 8.599 2.6 16 2.6c1.43 0 2.805.224 4.094.637a1 1 0 0 0 .61-1.904A15.4 15.4 0 0 0 16 .6C7.494.6.6 7.495.6 16S7.494 31.4 16 31.4 31.4 24.506 31.4 16q0-.647-.053-1.282a1 1 0 1 0-1.993.165q.045.552.046 1.117c0 7.401-6 13.4-13.4 13.4S2.6 23.401 2.6 16M28.088 2.86a1 1 0 1 0-1.777-.919l-2.4 4.636a1 1 0 0 0 .889 1.46h2.297l-.07.126-1.646 2.95a1 1 0 0 0 1.746.974l1.646-2.95.642-1.15.19-.34.05-.091.013-.024.004-.006v-.001l-.872-.488.873.487a1 1 0 0 0-.873-1.487h-2.357z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-electric_svg__a",
    x1: 16,
    x2: 16,
    y1: 21.6,
    y2: 15.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-electric_svg__b",
    x1: 15.999,
    x2: 15.999,
    y1: 13.6,
    y2: 10.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "faq-electric_svg__c",
    x1: 16,
    x2: 16,
    y1: 31.4,
    y2: 0.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgFaqElectric;